exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2bBmV7C3mFW69jpXY7w7Bn ._3_2jKHXYAs8mQIX24AmGkx{margin:auto;text-align:center;display:flex;justify-content:space-around}._2bBmV7C3mFW69jpXY7w7Bn ._20FQ655PW3L4L82sdxYHl6{text-align:center;color:#424242;padding-left:1em;padding-right:1em}._2bBmV7C3mFW69jpXY7w7Bn ._20FQ655PW3L4L82sdxYHl6 ._3rSF0DRSSd_sJTrikDVh_p{margin-top:1em;margin-bottom:1em;text-transform:uppercase;font-weight:bold;color:#9e9e9e;letter-spacing:0.2rem}._2bBmV7C3mFW69jpXY7w7Bn ._20FQ655PW3L4L82sdxYHl6 ._1NIrwAg7T_nmIN7NL6wnZn img,._2bBmV7C3mFW69jpXY7w7Bn ._20FQ655PW3L4L82sdxYHl6 ._1NIrwAg7T_nmIN7NL6wnZn video{height:30vh}\n", ""]);

// Exports
exports.locals = {
	"CarouselModal": "_2bBmV7C3mFW69jpXY7w7Bn",
	"ctaContainer": "_3_2jKHXYAs8mQIX24AmGkx",
	"TipsCarousel": "_20FQ655PW3L4L82sdxYHl6",
	"title": "_3rSF0DRSSd_sJTrikDVh_p",
	"imgContainer": "_1NIrwAg7T_nmIN7NL6wnZn"
};